import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { AppoggioService } from 'src/app/_servizi/appoggio.service';

@Component({
  selector: 'app-specifiche-vino',
  templateUrl: './specifiche-vino.component.html',
  styleUrls: ['./specifiche-vino.component.css']
})
export class SpecificheVinoComponent implements OnInit, OnChanges {

  get isMobile() {
    return this.appoggioService.getFromMobile();
  }

  @Input() specifiche: any;
  @Input() vino: any;

  specificheFiltered = [];

  panelOpenState = true;

  constructor(
    private appoggioService: AppoggioService
  ) {

  }

  ngOnChanges(changes: SimpleChanges): void {
    this.specificheFiltered = this.specifiche.filter(specifica => specifica.data != null && specifica.data !== '');
    this.panelOpenState = this.isMobile ? false : true;
  }

  ngOnInit(): void {
  }

  converti(testo) {
    const map: { [key: string]: string } = {
      'â€™': '’',
      'Ã¨': 'è',
      'Ã': 'à',
      'Ã¬': 'ì',
      'Ã²': 'ò',
      'Ã¹': 'ù',
      'Ã©': 'é',
      'Â': '',
      'â': 'à',
      '€': '€',
      'Ã¼': 'ü',
      'Ã¶': 'ö',
      'Ã¤': 'ä',
      'ÃŸ': 'ß',
      'Ã„': 'Ä',
      'Ã–': 'Ö',
      'Ãœ': 'Ü'
    };

    return testo && testo !== '' ? testo.replace(/â€™|Ã¨|Ã|Ã¬|Ã²|Ã¹|Ã©|Â|â|€|Ã¼|Ã¶|Ã¤|ÃŸ|Ã„|Ã–|Ãœ/gi, (matched) => map[matched]) : testo;
  }
}
